import { defineMessages } from "react-intl";

const messages = defineMessages({
    rename: {
        id: "general.rename",
    },
    duplicate: {
        id: "planCard.duplicate",
    },
    delete: {
        id: "general.delete",
    },
    deleteTitle: {
        id: "deleteTest.title",
    },
    deleteQuestion: {
        id: "deleteTest.question",
    },
    cancel: {
        id: "general.cancel",
    },
    report: {
        id: "planCard.report",
    },
    move: {
        id: "planCard.move",
    },
    moveTitle: {
        id: "planCard.move.title",
    },
    pack: {
        id: "planCard.move.pack",
    },
    deleteHomeworkTitle: {
        id: "deleteHomework.title",
    },
    deleteHomeworkText: {
        id: "deleteHomework.text",
    },
    changeDate: {
        id: "homework.changeDate",
    },
    modify: {
        id: "general.modify",
    },
    modifySomething: {
        id: "account.modal.changeSomething",
    },
    homeworkDescription: {
        id: "homework.description.teacherSide",
    },
});

export default messages;
